import { apiActions } from '../../_core/api';
import { Middleware } from 'redux';
import grb2Actions, {
	grb2Constants,
	TGRB2Actions,
	EGRB2Actions,
} from './actions';
import { IStore } from '../../store';
import { commonUtils } from '../../_common';
import { jobActions } from '../../_core/job';
import { IAuthActions } from '../auth/actions';
import { EMARPOLDocuments, EMARPOLModelName } from '../marpol/@types';
import { IGRB2 } from './@types';

const grb2Middleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
		(next) =>
			(action: TGRB2Actions | IAuthActions) => {
				switch (action.type) {
					case EGRB2Actions.HISTORY_LOAD: {
						next(action);
						const job = jobActions(grb2Constants.FEATURE, action.type);
						const { providedFilters: filters } = action.payload;
						dispatch(grb2Actions.document.filterSet(filters));

						dispatch(
							apiActions.apiRequest<{ logs: { docs: IGRB2[] } }>({
								feature: action.type,
								method: 'GET',
								url: grb2Constants.API,
								queryParams: {
									vesselId: filters.vesselId,
									marpolType: EMARPOLDocuments.GRB2,
									modelName: EMARPOLModelName.MARPOL,
									weekStart: filters.startDate,
									weekEnd: filters.endDate,
									state: {
										$eq: filters?.state ?? undefined
									},
									sortOrder: filters?.sortOrder ?? undefined,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										const grb2Records = data.logs.docs.filter(
											(doc) => doc.marpolType === EMARPOLDocuments.GRB2
										);
										dispatch(
											grb2Actions.document.historySet(
												commonUtils.arrayToObject(grb2Records)
											)
										);
										dispatch(job.success({}));
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					default:
						next(action);
				}
			};
export default grb2Middleware;
